import * as roles from '@purple/match-graphql-schema/lib/schema/support/roles'; // eslint-disable-line import/no-extraneous-dependencies

export const LOGIN_USER_REQUEST = 'LOGIN_USER_REQUEST';
export const LOGIN_USER_FAILURE = 'LOGIN_USER_FAILURE';
export const LOGIN_USER_SUCCESS = 'LOGIN_USER_SUCCESS';
export const LOGOUT_USER = 'LOGOUT_USER';
export const COMMUNITY_SERVERLESS = 'COMMUNITYSERVERLESS';
export const DISABLE_LEGACY_COMMUNITY = 'DISABLE_LEGACY_COMMUNITY';

// security roles defined in Azure AD

export const {
  SUPER_ADMIN_ROLE,
  ADMIN_ROLE,
  SUPPORT_ROLE,
  SALES_OPS_ROLE,
  COMMUNITY_ROLE,
  COMMUNITY_MANAGER_ROLE,
} = roles;

export const APP_ROLES = [
  SUPER_ADMIN_ROLE, ADMIN_ROLE, SUPPORT_ROLE, SALES_OPS_ROLE, COMMUNITY_ROLE, COMMUNITY_MANAGER_ROLE,
];

export const ADMIN_ROLES = [
  SUPER_ADMIN_ROLE, ADMIN_ROLE,
];

export const NON_VIEW_ONLY_ROLES = [
  SUPER_ADMIN_ROLE, ADMIN_ROLE, SUPPORT_ROLE, SALES_OPS_ROLE,
];

export const SCHOOL_CORE_LOOKUP_ROLES = [
  SUPER_ADMIN_ROLE, ADMIN_ROLE, SUPPORT_ROLE,
];

export const COMMUNITY_VIEW_ROLES = [
  SUPER_ADMIN_ROLE, ADMIN_ROLE, SUPPORT_ROLE, COMMUNITY_ROLE, COMMUNITY_MANAGER_ROLE,
];

export const COMMUNITY_ONLY_ROLES = [
  COMMUNITY_ROLE, COMMUNITY_MANAGER_ROLE,
];
